import React from "react";

export default function EnergyBanner() {
  return (
    <section className="py-10 sm:py-16 font-poppins" >
      <div className="max-w-3xl mx-auto px-4 sm:px-6">
        <div className="rounded-xl p-5 sm:p-8 text-center"
        style={{ border: "2px solid #00C7EF", backgroundColor: "#0F1030" }}>

          {/* Title */}
          <h3 className="text-lg sm:text-4xl font-extrabold mb-4 sm:mb-6" style={{ color: "#00C7EF" }}>
            Energy-Efficient HVAC Solutions
          </h3>

          {/* Checkmark + text */}
          <div className="flex items-start gap-3 sm:gap-4 text-left">
            <div
              className="flex-shrink-0 w-8 h-8 sm:w-10 sm:h-10 rounded-full flex items-center justify-center mt-1"
              style={{ backgroundColor: "#00C7EF" }}
            >
              <svg className="w-4 h-4 sm:w-6 sm:h-6" fill="none" stroke="white" strokeWidth="3" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
              </svg>
            </div>
            <p className="text-white text-xs sm:text-sm leading-relaxed">
              SmartCool helps clients <span className="font-bold">reduce electricity consumption</span> through{" "}
              <span className="font-bold">
                modern inverter-technology air conditioning systems, optimized HVAC design, and professional energy audits.
              </span>{" "}
              Our goal is to deliver cooling solutions that provide maximum comfort while minimizing long-term operating costs.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}